import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AboutMe from './components/AboutMe/AboutMe';
import Header from './components/Header/Header';
import Projects from './components/Projects/Projects';
import MotionClicker from './components/Games/MotionClicker/MotionClicker';
import RotatingStar from './components/Games/RotatingStar/RotatingStar';
import ClickSpeed from './components/Games/ClickSpeed/ClickSpeed';
import MomentumSpinner from './components/Games/MomentumSpinner/MomentumSpinner';
import ShrinkingTarget from './components/Games/ShrinkingTarget/ShrinkingTarget';
import TestLatency from './components/Games/TestLatency/TestLatency';
import UnicornRun from './components/Games/UnicornRun/UnicornRun';
import AsteroidDefense from './components/Games/AsteroidDefense/AsteroidDefense';
import GamesLanding from './components/Games/GamesLanding/GamesLanding';
import Click6 from './components/Games/Click6/Click6';
import ModernNinja from './components/Games/ModernNinja/ModernNinja';
import NinjaStats from './components/Games/ModernNinja/NinjaStats';
import styles from './App.module.css';
import AboutMeSide from './components/AboutMe/AboutMeSide';
import NotFound from './components/NotFound/NotFound';

import ThreeByTwo from './components/Games/ModernNinja/SubGames/ThreeByTwo';
import SevenYardDraw from './components/Games/ModernNinja/SubGames/SevenYardDraw';
import BillDrill from './components/Games/ModernNinja/SubGames/BillDrill';
import TwentyFiveYardShot from './components/Games/ModernNinja/SubGames/TwentyFiveYardShot';
import FullTest from './components/Games/ModernNinja/SubGames/FullTest';
import ThreeYardReload from './components/Games/ModernNinja/SubGames/ThreeYardReload';
import DepthTransitions from './components/Games/ModernNinja/SubGames/DepthTransitions';
import TexasStarNinja from './components/Games/ModernNinja/SubGames/TexasStarNinja';
import Click6Ninja from './components/Games/ModernNinja/SubGames/Click6Ninja';
import Click6NinjaGrid from './components/Games/ModernNinja/SubGames/Click6NinjaGrid';
import Click6NinjaW from './components/Games/ModernNinja/SubGames/Click6NinjaW';
import OneOneTwoOneOneDrill from './components/Games/ModernNinja/SubGames/OneOneTwoOneOneDrill';

function App() {
  // when in prod, don't be outputting to console.
  if (process.env.NODE_ENV === 'production') {
    console.log = () => { };
    console.error = () => { };
    console.debug = () => { };
  }
  // console.log('test');

  return (
    <>
      <Routes>
        <Route path="/" element={
          <>
            <Header />
            <div className={styles.wrapper}>
              <div className={styles.left}>
                <AboutMeSide />
              </div>
              <div className={styles.right}>
                <AboutMe />
                <Projects />
              </div>
            </div>
          </>
        } />
        <Route path="/games" element={<GamesLanding />} />
        <Route path="/motion-clicker" element={<MotionClicker />} />
        <Route path="/rotating-star" element={<RotatingStar />} />
        <Route path="/click-speed" element={<ClickSpeed />} />
        <Route path="/momentum-spinner" element={<MomentumSpinner />} />
        <Route path="/shrinking-target" element={<ShrinkingTarget />} />
        <Route path="/test-latency" element={<TestLatency />} />
        <Route path="/unicorn-run" element={<UnicornRun />} />
        <Route path="/asteroid-defense" element={<AsteroidDefense />} />
        <Route path="/click-6" element={<Click6 />} />
        <Route path="/modern-ninja" element={<ModernNinja />} />
        <Route path="/modern-ninja/stats" element={<NinjaStats />} />
        <Route path="/modern-ninja/3x2" element={<ThreeByTwo />} />
        <Route path="/modern-ninja/7yd" element={<SevenYardDraw />} />
        <Route path="/modern-ninja/bill" element={<BillDrill />} />
        <Route path="/modern-ninja/25yd" element={<TwentyFiveYardShot />} />
        <Route path="/modern-ninja/full" element={<FullTest />} />
        <Route path="/modern-ninja/3y-reload" element={<ThreeYardReload />} />
        <Route path="/modern-ninja/depth-transitions" element={<DepthTransitions />} />
        <Route path="/modern-ninja/texas-star" element={<TexasStarNinja />} />
        <Route path="/modern-ninja/1-1-2-1-1" element={<OneOneTwoOneOneDrill />} />
        <Route path="/modern-ninja/click-6" element={<Click6Ninja />} />
        <Route path="/modern-ninja/click-6-grid" element={<Click6NinjaGrid />} />
        <Route path="/modern-ninja/click-6-w" element={<Click6NinjaW />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
